"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcFetch = exports.withOidcFetch = void 0;
var react_1 = __importDefault(require("react"));
var oidc_1 = __importDefault(require("./vanilla/oidc"));
var defaultConfigurationName = "default";
var fetchWithToken = function (fetch, getOidcWithConfigurationName) { return function (url, options) {
    if (options === void 0) { options = { method: 'GET' }; }
    return __awaiter(void 0, void 0, void 0, function () {
        var headers, optionTmp, oidc, accessToken, newOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    headers = new Headers();
                    optionTmp = __assign({}, options);
                    if (optionTmp.headers) {
                        headers = !(optionTmp.headers instanceof Headers)
                            ? new Headers(optionTmp.headers)
                            : optionTmp.headers;
                    }
                    oidc = getOidcWithConfigurationName();
                    if (!oidc.syncTokensAsyncPromise) return [3 /*break*/, 2];
                    return [4 /*yield*/, oidc.syncTokensAsyncPromise];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    accessToken = oidc.tokens ? oidc.tokens.accessToken : null;
                    if (!headers.has('Accept')) {
                        headers.set('Accept', 'application/json');
                    }
                    if (accessToken) {
                        headers.set('Authorization', "Bearer ".concat(accessToken));
                        if (!optionTmp.credentials) {
                            optionTmp.credentials = 'same-origin';
                        }
                    }
                    newOptions = __assign(__assign({}, optionTmp), { headers: headers });
                    return [4 /*yield*/, fetch(url, newOptions)];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}; };
var withOidcFetch = function (fetch, configurationName) {
    if (fetch === void 0) { fetch = null; }
    if (configurationName === void 0) { configurationName = defaultConfigurationName; }
    return function (WrappedComponent) { return function (props) {
        var newFetch = (0, exports.useOidcFetch)(fetch || props.fetch, configurationName).fetch;
        return react_1.default.createElement(WrappedComponent, __assign({}, props, { fetch: newFetch }));
    }; };
};
exports.withOidcFetch = withOidcFetch;
var useOidcFetch = function (fetch, configurationName) {
    if (fetch === void 0) { fetch = null; }
    if (configurationName === void 0) { configurationName = defaultConfigurationName; }
    var previousFetch = fetch || window.fetch;
    var getOidc = oidc_1.default.get;
    var getOidcWithConfigurationName = function () { return getOidc(configurationName); };
    var newFetch = fetchWithToken(previousFetch, getOidcWithConfigurationName);
    return { fetch: newFetch };
};
exports.useOidcFetch = useOidcFetch;
//# sourceMappingURL=FetchToken.js.map